import { render } from "./patient_medical_card.vue?vue&type=template&id=4d900b14"
import script from "./patient_medical_card.vue?vue&type=script&lang=js"
export * from "./patient_medical_card.vue?vue&type=script&lang=js"

import "./patient_medical_card.vue?vue&type=style&index=0&id=4d900b14&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__